<template>
    <div class="titulo-secao">{{titulo}}</div>
</template>

<script>
export default {
    name: 'ComprasDiretasAbertasTituloSecao',
    props: {
        titulo: {
            required: true,
            type: String
        }
    }
}
</script>

<style scoped lang="stylus">
    .titulo-secao
        padding 10px 20px 0
        color var(--v-primary-base)
        font-weight bold
        font-size 14px
</style>